import { getLmsStaffOnly } from './lms-access'

// Whether this person sees the LMS admin at all (lms-access.js): while the
// server says the LMS is staff-only, system administrators and root only.
// Opened by the server, everyone does, and the LMS role gates each entry as
// before. Read at call time; a component that calls it also calls
// useLmsAccess, so it draws again when the server's answer arrives.
export const lmsAdminVisible = state => !getLmsStaffOnly() || !!(state && (state.isSysAdmin || state.isSysRoot))

// Whether the connection drawer's API keys panel exists (Phase D D7): only
// once the server has opened the LMS. While it is staff-only the LMS
// registers no route that creates a key bound to a connection (404, not
// 403), and refuses every API key (401), so the panel is absent for
// everyone, system administrators and root included. (The LMS's own API key
// pages and their six routes are retired.) Read at call time, not import.
export const lmsApiKeysVisible = () => !getLmsStaffOnly()

// Whether the session's claims have arrived. The auth context starts with
// none until the first refresh, so before then nobody is a system
// administrator yet and a gate must wait rather than say "not found".
export const claimsKnown = state => !!(state && state.jwtClaims && Object.keys(state.jwtClaims).length > 0)
